export const SUPPORTED_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif'];
export const SUPPORTED_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif'];
export const SUPPORTED_IMAGE_ACCEPT = [...SUPPORTED_IMAGE_MIME_TYPES, ...SUPPORTED_IMAGE_EXTENSIONS].join(',');

export function normalizeAcceptedFileTypes(accepted: string | string[]): string[] {
    if (Array.isArray(accepted)) {
        return accepted.filter(Boolean).map((type) => type.toLowerCase().trim());
    }

    if (typeof accepted === 'string') {
        return accepted
            .split(',')
            .map((type) => type.toLowerCase().trim())
            .filter(Boolean);
    }

    return [];
}
